import React from "react";

const ResetButton = ({ onReset }) => (
  <button type="button" className="btn-reset" onClick={onReset}>
    Reset Filter
  </button>
);

export default ResetButton;
